module Meevo.Plugins.DrawerManager {
    "use strict";

    export class PayOutSection extends Meevo.Plugins.DrawerManager.DrawerManagerSectionBase {

        public amount: number;
        public payOutReason: Meevo.Model.PayInOutReasons;
        public reasons: Meevo.Model.PayInOutReasons[];
        public note: string;
        public payOutDate: Date;
        public payOutTimeSegmented: any;
        public payOutTime: any;

        public payOutId: string;

        public isSaved: boolean = false;
        canSave = true;

        constructor(protected drawerManagerContext: Meevo.Plugins.DrawerManager.DrawerManagerContext,
            protected dataService: Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected printService: Meevo.Components.Common.IPrintService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            private $translate: angular.translate.ITranslateService,
            personalHeader: boolean,
            personalFooter: boolean) {

            super(DrawerManager.DrawerManagerSectionTypeEnum.PayOut, drawerManagerContext, "payOut", personalHeader, personalFooter);

            this.loadReasons();

            this.payOutTimeSegmented = {
                value: moment("09:00", "HH:mm").toDate()
            };
            this.payOutDate = moment(new Date()).toDate();
        }

        payOutDateTimeChanged() {
            var time = moment(this.payOutTimeSegmented.value.getHours() + ":" + this.payOutTimeSegmented.value.getMinutes(), "h:m a").toDate();
            this.payOutTime = moment(this.payOutDate).startOf('day')
                .hours(moment(time).hours())
                .minutes(moment(time).minutes())
                .toDate();
        }

        loadReasons = () => {
            this.dataService.getListPaged("payInOutReasons",
                {
                    criteria: {
                        payInOutType: Meevo.Model.PayInOutEnum.PayOut,
                    },
                    itemsPerPage: 1000
                })
                .then((data) => {
                    this.reasons = data;
                });
        }

        reset() {
            super.reset();
            this.payOutId = null;
            this.amount = null;
            this.payOutReason = null;
            this.note = null;

            this.payOutDate = this.context.getPayInOutDate();
        }
        initialize(payOut: Meevo.Model.PayInOut) {
            this.payOutId = payOut.id;
            this.amount = payOut.cashAmount;
            for (var i = 0; i < this.reasons.length; i++) {
                if (this.reasons[i].displayName == payOut.reason.displayName) {
                    this.payOutReason = this.reasons[i];
                    break;
                }
            }
            this.note = payOut.note;
            this.populateDateTime(payOut);
        }
        getSectionName() {
            return this.context.selectedDrawer.displayName + " - Pay-Out/Remove Cash";
        }
        printReceipt() {
            if (!Number(this.amount) || !this.payOutReason) {
                return;
            }
            if (!this.isSaved) {
                this.modalService.confirm("MESSAGE_PAY_OUT_PRINT").then((result) => {
                    if (result) {
                        this.save(true);
                    }
                });
            } else {
                var options = {
                    url: `/api/PayOut/${this.payOutId}/Receipt`,
                    method: 'GET',
                    params: {
                        locale: this.appSettings.APP_COUNTRYID,
                        timeFormat: this.appSettings.APP_TIME_FORMAT,
                    }
                };                
                //TODO: this.context.selectedPrinter must match the one selected in the print service
                this.printService.printCustom(options).then(() => {
                    this.cancel();
                });
            }
        }
        getReasons = () => {
            return this.reasons;
        }

        save = (doPrint = false) => {
            if (!Number(this.amount) || !this.payOutReason) {
                return;
            }
            var payOutObj: Meevo.Model.PayInOut = {
                id: this.payOutId,
                cashAmount: Number(this.amount),
                reason: this.payOutReason,
                note: this.note,
                payInOutType: Meevo.Model.PayInOutEnum.PayOut,
                drawerId: this.context.selectedDrawer.id,
                drawerSessionId: this.context.selectedDrawer.drawerSession.id,
                paymentCategory: Model.PaymentCategoryEnum.Cash,
            };

            if (this.context.selectedDrawer.drawerState == Model.DrawerStateEnum.Close) {
                var time = moment(this.payOutTimeSegmented.value.getHours() + ":" + this.payOutTimeSegmented.value.getMinutes(), "h:m a").toDate();
                payOutObj.payInOutDateTime = moment(this.payOutDate).startOf('day')
                    .hours(moment(time).hours())
                    .minutes(moment(time).minutes()).format("YYYY-MM-DD HH:mm:ss")
                    .toString();
            }

            this.canSave = false;
            this.context.payOutCash(payOutObj)
                .then((response) => {
                    this.payOutId = response.id;

                    this.context.getDrawerSession(this.context.selectedDrawer.id, true, this.context.selectedDrawer.drawerSession.id).then((data) => {
                        this.context.getDrawerSessionPayInOut(Model.PaymentCategoryEnum.Cash);
                        this.isSaved = true;

                        if (doPrint) {
                            this.printReceipt();
                        } else {
                            this.cancel();
                        }
                    });
                })
                .finally(() => {
                    this.canSave = true;
                });
        }
        cancel() {
            this.context.closeSection();
            this.isSaved = false;
        }

        populateDateTime(payOut) {
            if (this.context.selectedDrawer.drawerState == Model.DrawerStateEnum.Close) {
                var time = payOut.dateCreated.getHours() + ":" + payOut.dateCreated.getMinutes();
                this.payOutTimeSegmented = {
                    value: moment(time, "HH:mm").toDate()
                };
                this.payOutDate = moment(payOut.dateCreated).toDate();
            }
        }

    }

}